<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Tipo:"
    id="selectTipo"
    placeholder="Selecione o Tipo"
    :multiple="false"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
import { ListGoalTypes } from '@/enums/enumGoalMetricTypes.js'

export default {
  name: 'NxSelectTipoMeta',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    initialValue: {
      type: [Number, null],
      required: false
    }
  },
  mounted () {
    if (this.initialValue !== undefined && this.initialValue !== null) {
      this.localValue = this.listOptions.find(x => x.value === this.initialValue) || null
    }
  },
  data () {
    return {
      listOptions: [{
        value: ListGoalTypes.INCREMENTAL,
        text: 'Incremental'
      },
      {
        value: ListGoalTypes.PRODUÇÃO,
        text: 'Produção'
      }],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoMeta.vue